<container-element [ngSwitch]="this.operation">
  <!-- Add -->
  <div *ngSwitchCase="1">
    <div class="d-flex flex-row types__buisness justify-content-between">
      <div>{{ 'VENUES.VENUE' | translate }} *</div>
      <div *ngIf="item.invalid && (item.dirty || item.touched)" class="alert alert-danger">
        <div class="d-flex flex-row alert-danger-content">
          <div class="alert-danger-info" matTooltipClass="tooltip-danger"
            matTooltip="{{ 'INFO.CHOOSE_MORE_PATTERN' | translate }}">
            <div>?</div>
          </div>
        </div>
      </div>
    </div>
    <p-dropdown autoWidth="false" [options]="venuesList" [(ngModel)]="selectedVenue" [required]="true" #item="ngModel"
      (onChange)="shareSelectedVenueItem()" optionLabel="name" [showClear]="false"
      placeholder="{{ 'INFO.SELECT_VENUE' | translate }}">
      <ng-template pTemplate="selectedItem">
        <div class="" *ngIf="selectedVenue">
          <div>{{selectedVenue.name}}</div>
        </div>
      </ng-template>
    </p-dropdown>
  </div>
  <!-- Edit -->
  <div *ngSwitchCase="2">
    <div class="d-flex flex-row types__buisness justify-content-between">
      <div>{{ 'VENUES.VENUE' | translate }} *</div>
      <div *ngIf="item.invalid && (item.dirty || item.touched)" class="alert alert-danger">
        <div class="d-flex flex-row alert-danger-content">
          <div class="alert-danger-info" matTooltipClass="tooltip-danger"
            matTooltip="{{ 'INFO.CHOOSE_MORE_PATTERN' | translate }}">
            <div>?</div>
          </div>
        </div>
      </div>
    </div>
    <p-dropdown [options]="venuesList" [(ngModel)]="selectedVenue" (onChange)="shareSelectedVenueItem()"
      [required]="true" #item="ngModel" optionLabel="name" [showClear]="false"
      placeholder="{{ 'INFO.SELECT_VENUE' | translate }}">
      <ng-template pTemplate="selectedItem">
        <div class="" *ngIf="selectedVenue">
          <div>{{selectedVenue.name}}</div>
        </div>
      </ng-template>
    </p-dropdown>
  </div>
  <!-- Read -->
  <div *ngSwitchCase="4">
    <div class="d-flex flex-row types__buisness justify-content-between">
      <div>{{ 'VENUES.VENUE' | translate }}</div>
      <div *ngIf="item.invalid && (item.dirty || item.touched)" class="alert alert-danger">
        <div class="d-flex flex-row alert-danger-content">
          <div class="alert-danger-info" matTooltipClass="tooltip-danger"
            matTooltip="{{ 'INFO.CHOOSE_MORE_PATTERN' | translate }}">
            <div>?</div>
          </div>
        </div>
      </div>
    </div>
    <p-dropdown [options]="venuesList" [(ngModel)]="selectedVenue" (onChange)="shareSelectedVenueItem()"
      [required]="true" #item="ngModel" optionLabel="name" optionDisabled="name" [showClear]="false"
      placeholder="{{ 'INFO.SELECT_VENUE' | translate }}">
      <ng-template pTemplate="selectedItem">
        <div class="" *ngIf="selectedVenue">
          <div>{{selectedVenue.name}}</div>
        </div>
      </ng-template>
    </p-dropdown>
  </div>

  <!--default case when there are no matches -->
  <div *ngSwitchDefault>...</div>
</container-element>